<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="Close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      {{ messagebody }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="cancel()">{{ btnCancel }}</button>
      <button type="button" class="btn btn-primary" (click)="ok()">{{ btnOk }}</button>
    </div>
